<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()" data-cy="create-pcg-entry-dialog">
  <span mat-dialog-title data-cy="create-pcg-entry-title">{{ title }}</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    <app-pcg-entry-form
      [company]="company"
      [accountingConfig]="accountingConfig"
      [disableCentralizer]="disableCentralizer"
      [pcgEntries]="pcgEntries"
      [pcgEntryForm]="pcgEntryForm"
    ></app-pcg-entry-form>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button
      tiime-button
      color="accent"
      strocked
      large
      [disabled]="pcgEntryForm.disabled"
      (click)="cancel()"
      data-cy="create-pcg-entry-cancel-btn"
    >
      Annuler
    </button>
    <button
      tiime-button
      color="accent"
      large
      raised
      [disabled]="pcgEntryForm.disabled"
      (click)="submitPcgEntryForm()"
      data-cy="create-pcg-entry-save-btn"
    >
      Ajouter
    </button>
  </mat-dialog-actions>
</tiime-dialog>
